import React from "react";
import { motion } from "framer-motion";
import { Mail, Facebook, Cake, Briefcase, Sparkles } from "lucide-react";
import { VENUE } from "../lib/venue";

const occasions = [
  { icon: Cake, label: "Birthdays" },
  { icon: Briefcase, label: "Work Parties" },
  { icon: Sparkles, label: "Engagements" },
];

export const PrivateHire = () => {
  return (
    <section
      id="hire"
      data-testid="private-hire-section"
      className="relative py-24 sm:py-32 px-6 sm:px-10 bg-[#111114] border-t border-white/5 overflow-hidden"
    >
      {/* Decorative diagonal stripe */}
      <div className="absolute -top-32 -right-32 w-[500px] h-[500px] bg-[#F5A623]/5 blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-xs uppercase tracking-[0.3em] text-[#F5A623] font-semibold">
            / Private Hire
          </span>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl text-[#FDFBF7] uppercase mt-4 leading-[0.9]">
            Take over
            <br />
            <span className="text-[#F5A623]">the whole joint.</span>
          </h2>
          <p className="mt-6 text-[#FDFBF7]/70 text-lg leading-relaxed max-w-lg">
            Birthdays, work do's, engagement parties — whatever you're
            celebrating, we'll pour the drinks, turn up the speakers and let you
            make it your own.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            {occasions.map(({ icon: Icon, label }) => (
              <div
                key={label}
                className="flex items-center gap-2 border border-white/15 px-4 py-2.5 text-sm text-[#FDFBF7]/80"
              >
                <Icon size={16} className="text-[#F5A623]" />
                <span className="uppercase tracking-wider font-semibold text-xs">
                  {label}
                </span>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="bg-[#0A0A0A] border border-[#F5A623]/30 p-8 sm:p-10 shadow-[8px_8px_0px_0px_rgba(245,166,35,0.25)]"
          data-testid="private-hire-contact-card"
        >
          <h3 className="font-display text-3xl uppercase text-[#FDFBF7] mb-2">
            Get in Touch
          </h3>
          <p className="text-[#FDFBF7]/60 mb-8">
            Drop us a message and we'll get back to you with availability.
          </p>

          <div className="space-y-5">
            <a
              href={`mailto:${VENUE.email}?subject=Private%20Hire%20Enquiry`}
              data-testid="contact-email"
              className="group flex items-center gap-4 border border-white/10 hover:border-[#F5A623] p-5 transition-colors"
            >
              <div className="w-12 h-12 bg-[#F5A623]/10 group-hover:bg-[#F5A623] flex items-center justify-center transition-colors">
                <Mail size={20} className="text-[#F5A623] group-hover:text-black" />
              </div>
              <div className="min-w-0">
                <div className="text-[10px] uppercase tracking-[0.25em] text-[#FDFBF7]/50 font-semibold">
                  Email
                </div>
                <div className="text-[#FDFBF7] font-semibold truncate">
                  {VENUE.email}
                </div>
              </div>
            </a>

            <a
              href={VENUE.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-facebook"
              className="group flex items-center gap-4 border border-white/10 hover:border-[#F5A623] p-5 transition-colors"
            >
              <div className="w-12 h-12 bg-[#F5A623]/10 group-hover:bg-[#F5A623] flex items-center justify-center transition-colors">
                <Facebook size={20} className="text-[#F5A623] group-hover:text-black" />
              </div>
              <div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-[#FDFBF7]/50 font-semibold">
                  Message us
                </div>
                <div className="text-[#FDFBF7] font-semibold">
                  Facebook DM
                </div>
              </div>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
